<template>
    <div class="all">
        <div class="page-right w250 temp-right fr" v-if="!isPreview">
            <vue-scroll :ops="ops"  style="width:250px;height:100%">
                <div class="type-list">
                    <div class="type-top">
                        <h2 class=""><span class="switch" :class="status == 1 ? 'active' : ''" @click="oneButtonSwitch();">红头文件 <i class="icons switch-icon fr"></i></span></h2>
                    </div>
                    <div class="type-header">
                        <h2 class="title">选择模块</h2>
                    </div>
                    <draggable :list="list2" :options="{group:{name: falgs,pull:'clone'}, sort: false}" @end="end" class="dragArea">
                        <div v-for="element in list2" :key="element.id" class="list-complete-item text">
                            <i class="icons" :class="element.icon" v-show="element.type !== 1"></i>
                            <i class="iconfont" :class="element.icon" v-show="element.type === 1"></i>
                            {{element.name}}
                        </div>
                    </draggable>
                </div>
            </vue-scroll>
            
        </div>
        <div class="page-left pr260" v-if="!isPreview">
            <div class="detail-warp">
				<button class="btn btn-blue mb30" @click="$router.go(-1)">返回列表</button>
                <div class="redHeader mb30" :class="status == 1 ? '' : 'hide'">
                    <input class="template-title ac db color-red" type="text" placeholder="填写红头文件标题" v-model="tempform.redFileTit"/>
                    <input class="template-author ac db" type="text" placeholder="填写红头文件编号" v-model="tempform.redFileName"/>
                    <span class="redIcon"><i class="icons icons-star"></i></span>
                </div>
                <input class="template-title ac db" type="text" placeholder="填写报告标题" v-model="tempform.tit"/>
                <input class="template-author ac db" type="text" placeholder="填写作者名称" v-model="tempform.name"/>
                <div class="dragWrap">
                    <draggable :list="list1" :options="{group:'article', disabled: disabled}" @start="start22" @end="end22" class="dragArea11">
                        <div v-for="(element, index) in list1" :key="index">
                            <div class="tit">
                                <i class="icons del-sm-icon mt5 fr" @click="handleDel(index, element.id,element.chartId)"></i>
                                <input class="name" type="text" v-model="element.name"/>
                                <span class="drop-down ml20" v-if="element.showTab">
                                    <button class="btn btn-lightblue"><span class="text">{{element.curTab}}</span><i class="icons"></i></button> 
                                    <ul class="option">
                                        <li class="repTem" v-for="(item, ind) in element.tabList" :key="ind" @click="choseEchart(item,index,ind,element.chartId)">{{item}}</li>
                                    </ul>
                                </span>
                                <span class="drop-down mores ml20" v-if="element.showCity">
                                    <button class="btn btn-lightblue"><span class="text">{{element.curCity}}</span><i class="icons"></i></button> 
                                    <ul class="option">
                                        <li class="repTem" v-for="(item, ind) in cityList" :key="ind" @click="choseCity(item,index,ind)">{{item}}</li>
                                    </ul>
                                </span>
                            </div>
                            <div class="cont ac mt15">
                                <img :src="element.img" v-if="element.img != ''"/>
                                <textarea type="text" v-if="element.isText" class="input-textarea"  v-model="element.text"></textarea>
                            </div>
                        </div>
                    </draggable>
                </div>
                <div class="bottom ac mt20">
                    <button class="btn save btn-jbblue" :class="{ 'disabled': isActive==true }" @click="saveTemplete">保存模板</button>
                    <button class="btn save btn-jbblue ml20" @click="previewOpen" v-show="!isShow">预览模板</button>
                    <button class="btn save btn-none ml20" @click="previewBack" v-show="isShow">返回</button>
                </div>
            </div>
        </div>
        <div class="page-left" v-if="isPreview">
            <div class="detail-warp">
				<button class="btn btn-blue" @click="$router.go(-1)">返回列表</button>
                <div class="redHeader mb30" :class="status == 1 ? '' : 'hide'">
                    <div class="fs28 ac db color-red">{{tempform.redFileTit}}</div>
                    <p class="fs24 ac db mb10">{{tempform.redFileName}}</p>
                    <span class="redIcon"><i class="icons icons-star"></i></span>
                </div>
                <div class="fs24 ac db">{{tempform.tit}}</div>
                <div class="mt20 ac db">{{tempform.name}}</div>
                <div class="dragWrap mt20">
                    <div class="dragArea11">
                        <div v-for="(element, index) in list1" :key="index">
                            <div class="tit fs16">{{element.name}}</div>
                            <div class="cont ac mt15">
                                <p class="al" v-if="element.info!=undefined">{{element.info}}</p>    
                                <img :src="element.img" v-if="element.img != ''"/>
                                <div v-if="element.isText" class="al">{{element.text}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
import draggable from 'vuedraggable';
export default {
    components:{
        draggable
    }, 
    data() {
        return {
            ops: {
                vuescroll: {},
                scrollPanel: {},
                rail: {
                    keepShow:true
                },
                bar: {
                    hoverStyle: true,
                    onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
                    background: '#c4c4cc',
                }
            },
            sid:this.$route.query.id,
            isPreview:this.$route.query.isPreview,
            isFromTiming:this.$route.query.fromTiming,
            status:0,//红头文件显示状态
            tempform:{},
            falgs: 'article',
            disabled: false,
            list:[],
            list1: [],
            list2: [
                {id: 1, name:'文本',icon:'text-icon',img:'',isText:true,text:'',chartId:'text1'}, 
                                {id: 2, name: '报告简述',icon:'text-icon',img:'',isText:true,text:'本报告就加入素材的文章进行分析，共有**篇相关素材。其中，博客100篇，占比59%；微信98篇，占比54%；新闻40篇，占比45%。而论坛的比重最大，共有**篇，达到信息总量的60%。目前主要的报道集中在网易新闻、和讯论坛、中青网、新民网、百度、中国江苏网等几大站点。详细报告请继续浏览。',chartId:'text2'},
                                {id: 3, name:'事件走势',icon:'data1-icon',img:'/static/images/report/lineImg1.gif',chartId:'lineEchart',info:'据下图可知，2017年04月08日 00:00至2017年04月14日 23:59，微信信息xxx条，占比xx%；网页信息xxx条，占比xx%；微博舆情xxx条，占比xx%；论坛舆情信息xxx条，占比xx%；报刊信息xxx条，占比（3.67%）；舆情信息xxx条，占比xx%。'}, 
                                {id: 4, name:'分析词榜单',icon:'table-icon',img:'/static/images/report/gjcz.jpg',chartId:'analyticalWords'},
                				{id: 5, name:'首发媒体',icon:'table-icon',img:'/static/images/report/sfmt.jpg',chartId:'firstMedia'},
                				{id: 6, name:'热门文章',icon:'table-icon',img:'/static/images/report/listImg14.png',chartId:'hotArticle'},
                                {id: 7, name:'负面文章',icon:'table-icon',img:'/static/images/report/listImg14.png',chartId:'negativeArticle'},
                                // {id: 5, name:'热门视频',icon:'table-icon',img:'/static/images/report/listImg4.gif',chartId:'hotVedio'},
                				{id: 8, name:'情绪分布',icon:'ring-icon',img:'/static/images/report/moods.jpg',chartId:'emotionalProportion',info:'据下图可知，2019年08月08日 00:00:00至2019年08月14日 23:59:59，舆情信息中喜悦xxx条，占比xx%、赞扬xxx条，占比xx%、愤怒xxx条，占比xx%、悲伤xxx条，占比xx%、恐惧xxx条，占比xx%、厌恶xxx条，占比xx%、惊奇xxx条，占比xx%。'}, 
                                {id: 9, name:'情感属性',icon:'ring-icon',img:'/static/images/report/emotionImg0.gif',chartId:'emotionEchart',tabList:['趋势图','饼状图'],showTab:true,curTab:'趋势图',numId:0,maxId:0,info:'据下图可知，2019年08月08日 00:00:00至2019年08月14日 23:59:59，正面舆情信息xxx条，占比xx%；负面舆情信息xxx条，占比xx%；中性舆情信息xxx条，占比xx%。'}, 
                                {id: 10, name:'媒体分布',icon:'ring-icon',img:'/static/images/report/pieImg3.jpg',chartId:'pieEchart3',info:'据下图可知，2017年04月08日 00:00至2017年04月14日 23:59，微信信息xxx条，占比xx%；网页信息xxx条，占比xx%；微博舆情xxx条，占比xx%；论坛舆情信息xxx条，占比xx%；报刊信息xxx条，占比xx%；舆情信息xxx条，占比xx%。'}, 
                                {id: 11, name:'平台分布占比',icon:'ring-icon',img:'/static/images/report/pieImg2.jpg',chartId:'pieEchart5'}, 
                                // {id: 9, name:'用户画像',icon:'people-icon',img:'/static/images/report/barPieImg.gif',chartId:'barPieChart'}, 
                                {id: 12, name:'活跃渠道',icon:'menu-icon',img:'/static/images/report/listImg3.gif',chartId:'activeAccout'},
                                {id: 13, name:'敏感信息报道渠道',icon:'menu-icon',img:'/static/images/report/listImg1.gif',chartId:'sensitiveAccount'},
                                {id: 14, name:'影响力渠道',icon:'menu-icon',img:'/static/images/report/listImg2.gif',chartId:'impactAccount'},
                                {id: 15, name:'账号认证',icon:'ring-icon',img:'/static/images/report/pieImg4.gif',chartId:'pieEchart4'},
                                {id: 16, name:'传播力分布',icon:'data2-icon',img:'/static/images/report/barImg1.gif',chartId:'barEchart1'},
                                {id: 17, name:'平台分布',icon:'data2-icon',img:'/static/images/report/ptfb.jpg',chartId:'platformSpread',info:'据下图可知，2017年04月08日 00:00至2017年04月14日 23:59，微信信息xxx条，占比xx%；网页信息xxx）条，占比xx%；微博舆情xxx条，占比xx%；论坛舆情信息xxx条，占比xx%；报刊信息xxx条，占比xx%；舆情信息xxx条，占比xx%'},
                                {id: 18, name:'文章类型',icon:'ring-icon',img:'/static/images/report/pieImg2.gif',chartId:'pieEchart2'},
                                {id: 19, name:'热门词云',icon:'yun-icon',img:'/static/images/report/cloudImg.gif',chartId:'wordCloud',tabList:['词云图','饼图','雷达图'],showTab:true,curTab:'词云图',numId:0,maxId:0,info:'2019年08月08日 00:00:00至2019年08月14日 23:59:59，xxx一词出现频率最高，达xxx，其次是xxx，出现次数达xxx次。'},
                                {id: 20, name:'发布地区',icon:'map-icon',img:'/static/images/report/province/mapImg0.gif',chartId:'mapEchart',showCity:true,curCity:'全国',numId:0,maxId:0,info:'据下图显示，发布信息地域前十有北京、广东、上海、浙江、山东、四川、山西、河南、河北、安徽，其中北京舆情信息有xxx条，占比xx%；广东舆情信息有xxx条，占比xx%；上海舆情信息有xxx条，占比xx%；广东舆情信息有xxx条，占比xx%；山东舆情信息有xxx条，占比xx%；四川舆情信息有xxx条，占比xx%；山西舆情信息有xxx条，占比xx%；河南舆情信息有xxx条，占比xx%；河北舆情信息有xxx条，占比xx%；安徽舆情信息有xxx条，占比xx%。'},
                                {id: 21, name:'提及地区',icon:'map-icon',img:'/static/images/report/province/mapImg0.gif',chartId:'mapMentEchart',showCity:true,curCity:'全国',numId:0,maxId:0,info:'据下图显示，信息提及地区前十有北京、广东、上海、浙江、山东、四川、山西、河南、河北、安徽，其中北京舆情信息有xxx条，占比xx%；广东舆情信息有xxx条，占比xx%；上海舆情信息有xxx条，占比xx%；广东舆情信息有xxx条，占比xx%；山东舆情信息有xxx条，占比xx%；四川舆情信息有xxx条，占比xx%；山西舆情信息有xxx条，占比xx%；河南舆情信息有xxx条，占比xx%；河北舆情信息有xxx条，占比xx%；安徽舆情信息有xxx条，占比xx%。'},
                                {id: 22, name:'网民观点',icon:'icon-jilu',type:1,img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/images/report_netizen_view.jpg',chartId:'netizenView'},
                                {id: 23, name:'媒体观点',icon:'icon-jilu',type:1,img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/images/report_media_view.jpg',chartId:'mediaView'},
                                {id: 24, name:'预警趋势',icon:'data1-icon',img:'/static/images/report/warnImg1.gif',chartId:'barEchart'},
                                {id: 25, name:'处置建议',icon:'text-icon',img:'',isText:true,text:'对于舆情信息中具有潜在危害的事件及情况应给予关注并积极处理，防止不良影响产生及扩散。此外，密切关注此前敏感预警事件的发展情况，及时制定有效应对措施。鉴于分析结果中负面舆情时有发生， 应吸取相关经验教训，做好预防和处理工作。',chartId:'text3'}
                				// {id: 24, name:'事件脉络',icon:'timeline-icon',img:'/static/images/report/timeLine.jpg',chartId:'context'},
            ],
            btNum : ['一','二','三','四','五','六','七','八','九'],
            cityList:[],
            tplInit:'',
            isShow:false,
            isActive:false,
            maxName:{'emotionEchart':0,'wordCloud':0,'mapEchart':0,'mapMentEchart':0}
        }
    },
    mounted() {
        let that = this;
        that.cityAjax();
		if(that.sid!=undefined){
            that.editAjax();
        }
        
    },
    beforeDestroy(){
        let that = this;
        that.previewBack();
    },
    methods: {
        // 红头文件开关
        oneButtonSwitch () {
            let that = this;
            that.status = (that.status == 0)?1:0;
        },
        cityAjax(){
            let that = this;
            that.$axios.get('/static/city.json').then(r=>{
                that.cityList = r.data.shortProvince;   
            }).catch(error =>{
                // console.log(error);
            });

        },
        choseCity(name, index,num){
            this.list1[index].curCity = name;
            this.list1[index].img = '/static/images/report/province/mapImg'+num+'.gif';
        },
        choseEchart(name, index,num,id){
            this.list1[index].curTab = name;
            if(id=='emotionEchart'){
                this.list1[index].img = '/static/images/report/emotionImg'+num+'.gif';
            }else{
                this.list1[index].img = '/static/images/report/cloudImg'+num+'.gif';
            }    
        },
        end (ev) {
            let that = this;
            that.list = [];
            that.maxName={'emotionEchart':0,'wordCloud':0,'mapEchart':0,'mapMentEchart':0};
            if(that.list1.length>0){
                that.list1.forEach((ele,index) => {
                    let tempArr = {};
                    if (ele.numId != undefined){console.log(ele.numId);
                        tempArr.numId = ele.numId;
                        that.maxName[ele.chartId]++;
                        ele.numId++;
                    }
                    tempArr.id = ele.id;
                    tempArr.name = ele.name;
                    tempArr.img = ele.img;
                    tempArr.chartId = ele.chartId;
                    tempArr.isText = ele.isText;
                    tempArr.text = ele.text;
                    tempArr.showCity = ele.showCity;
                    tempArr.showTab = ele.showTab;
                    tempArr.curCity = ele.curCity;
                    tempArr.curTab = ele.curTab;
                    tempArr.tabList = ele.tabList;
                    tempArr.maxId = ele.maxId;
                    tempArr.info = ele.info;
                    that.list.push(tempArr)
                }); 
                that.list1 = that.list;
            }
            if (ev.to.className === 'dragArea11') {
                //that.$set(that.list2[ev.oldIndex], 'flag', true)
            }
        },
        start22 (event) {
            this.falgs = '222222'
        },
        end22 (ev) {
            // console.log(this.list1);
            this.falgs = 'article'
        },
        handleDel (index, id ,chartId) {
            this.list1.splice(index, 1)
            let q = this.list2.find((value, index, arr) => {
                return value.id === id
            })
            //this.$set(q, 'flag', false)
        },
        //保存模板
        saveTemplete(){
            let that = this,tplHtml='',zlHtml='',rmHtml='',zlIndex=0,rmIndex=0,btIndex = 0,isHas1=false,isHas2 = false,isHas3 = false,has3Text='';
            
            if(that.tempform.tit == undefined || that.tempform.tit == ''){
                that.$utils.alertText('请填写报告标题',200);
                return;
            }
            if(that.list1.length ===0){
                that.$utils.alertText('请选择模块',200);
                return;
            }
            if(that.status===1 && (that.tempform.redFileTit == undefined || that.tempform.redFileTit == '')){
                that.$utils.alertText('请填写红头文件标题',200);
                return;
            }
            if(that.status===1 && (that.tempform.redFileName == undefined || that.tempform.redFileName == '')){
                that.$utils.alertText('请填写红头文件编号',200);
                return;
            }
            if(that.status===1){
                tplHtml +='<div style="width:100%;max-width:1120px;padding:30px 0 0px;margin:0;color:#47a0e4;text-align:center;background:#fff;box-sizing: border-box;"><h1 style="margin:0 0 20px;font-size:32px;line-height: 1.1;color:#ed233d">'+that.tempform.redFileTit+'</h1><p style="color: #666;margin-bottom:10px">'+that.tempform.redFileName +'</p><img src="http://bsddata.oss-cn-hangzhou.aliyuncs.com/yuqing_oem/html/red_line.png" style="width:100%;"></div>';
                tplHtml +='<div style="width:100%;max-width:1120px;height:80px;padding:30px 0 22px 0;margin:0;color:#47a0e4;text-align:center;background:#fff;box-sizing: border-box;"><h1 style="margin:0;font-size:22px;font-weight:400;line-height: 1.1;">{{get_briefdoc_tit}}</h1></div>';
            }else{
                tplHtml +='<div style="width:100%;max-width:1120px;height:80px;padding:30px 0 22px 0;margin:0;color:#47a0e4;text-align:center;background:#fff;border-top:3px solid #47a0e4;border-bottom:1px solid #6cb3e9;border-top:0px;box-sizing: border-box;"><h1 style="margin:0;font-size:22px;font-weight:400;line-height: 1.1;">{{get_briefdoc_tit}}</h1></div>';
            }
            
            that.list1.forEach((ele,index) => {
                if (ele.maxId != undefined){
                     ele.maxId = that.maxName[ele.chartId];
                }
                if(ele.chartId == 'text1' || ele.chartId == 'text2' || ele.chartId == 'text3'){
                    zlIndex++;
                    let txt1 = ele.text;
                    if(ele.chartId == 'text2'){
                        txt1 = '{{get_briefdoc_'+ele.chartId+'}}';
                    }
                    let tempHtml1 = '<div style="padding:0 5px;page-break-inside:avoid;">'
                        +'<p style="width: 91.66666667%;padding:15px 15px 0;margin-bottom:15px;margin-left:1%;color:#47a0e4;font-size:16px;box-sizing: border-box;">'
                            +'<span>'+ zlIndex + '、' + ele.name+'</span>'
                        +'</p>'
                        +'<div style="margin-left:4.8%;width:95.2%;padding-right:15px;box-sizing: border-box">'
                            +'<div><span>'+txt1+'</span></div>'
                        +'</div><br/>'
                    +'</div>';
                    tplHtml += tempHtml1;
                }else if(ele.chartId == 'hotArticle' || ele.chartId == 'hotVedio' || ele.chartId =='negativeArticle' || ele.chartId == 'firstMedia'){
                    //isHas2 = true;
                    zlIndex++;
                    let tempHtml3 = '<div style="padding:0 5px;page-break-inside:avoid;">'
                        +'<p style="width: 91.66666667%;padding:15px 15px 0;margin-bottom:15px;margin-left:1%;color:#47a0e4;font-size:16px;box-sizing: border-box;">'
                            + zlIndex + '、' + ele.name
                        +'</p>'
                        +'<div style="margin-left:4.8%;width:95.2%;padding-right:15px;box-sizing: border-box">'
                            +'{{get_briefdoc_'+ele.chartId+'}}'
                        +'</div>'
                    +'</div><br/>';
                    tplHtml += tempHtml3;
                }else if(ele.chartId == 'analyticalWords' || ele.chartId == 'netizenView' || ele.chartId == 'mediaView'){//分析词榜单
                    //isHas2 = true;
                    zlIndex++;
                    let tempHtml = `
						<div style="padding:0 5px;page-break-inside:avoid;">
							<p style="width: 91.66666667%;padding:15px 15px 0;margin-bottom:15px;margin-left:1%;color:#47a0e4;font-size:16px;box-sizing: border-box;">
							    ${zlIndex}、${ele.name}
							</p>
							<div style="margin-left:4.8%;width:95.2%;padding-right:15px;box-sizing:border-box" class="contain-auto">
								<div class="width1000">
									{{get_briefdoc_${ele.chartId}}}
								</div>
							</div>
						</div>
					`;
                    tplHtml += tempHtml;
                }else if(ele.chartId == 'context'){//事件脉络
                    //isHas2 = true;
                    zlIndex++;
                    let tempHtml = `
						<div style="margin-left: 13%; width: 74%;position:relative;">
							<div style="position:relative;">
								<div style="position:absolute;top:0;left:50%;margin-left:-.5px;width:1px;height:100%;background:#666;"></div>
								{{get_briefdoc_${ele.chartId}}}
							</div>
						</div>
					`;
                    tplHtml += tempHtml;
                }else{//图表都进这个
                    //isHas1= true;
                    zlIndex++;
                    let tempHtml;
                    if(ele.chartId == 'activeAccout' ||ele.chartId == 'sensitiveAccount' ||ele.chartId == 'impactAccount'){
                        tempHtml = '<div style="padding:0 5px;page-break-inside:avoid;">'
                        +'<p style=" width: 91.66666667%;padding:15px 15px 0;margin-bottom:15px;margin-left:1%;color:#47a0e4;font-size:16px;box-sizing: border-box;">'
                            + zlIndex + '、' + ele.name
                        +'</p>'
                        +'<div style="margin-left: 13%; width: 74%;text-align:center;position:relative;">{{get_briefdoc_'+ele.chartId+'}}</div>'
                    +'</div><br/>';
                    }else{
                        let chartId = ele.chartId;
                        if(ele.numId!=undefined){
                            chartId = ele.chartId + ele.numId
                        }
                        let maptemp = '',temptxt='';
                        temptxt = '<div style="padding:0 5px;page-break-inside:avoid;">'
                        +'<p style="width: 91.66666667%;padding:15px 15px 0;margin-bottom:15px;margin-left:1%;color:#47a0e4;font-size:16px;box-sizing: border-box;">'
                            + zlIndex + '、' + ele.name
                        +'</p>'
                        +'<div style="margin-left:4.8%;width:95.2%;padding-right:15px;box-sizing: border-box" class="contain-auto">'
                            +'<div><span>{{get_briefdoc_'+chartId+'}}</span></div>'
                        +'</div>';
                    
                        if(ele.chartId == 'mapEchart'||ele.chartId == 'mapMentEchart'){
                            maptemp =  ' <div style="margin-left: 15%; width: 70%;text-align:center;position:relative;padding-top:20px" class="contain-auto">'
                                +'<table style="width:833px;border:1px solid #e3e3e3;border-collapse: collapse;">'
								+'<colgroup><col width="10%"/><col width="10%"/><col width="80%"/></colgroup>'
								+'<tbody>'
									+'<tr>'
										+'<th style="white-space: nowrap;padding:6px 12px;border:1px solid #e3e3e3;text-align:center;background:#edf1f7;">地区</th>'
										+'<th style="white-space: nowrap;padding:6px 12px;border:1px solid #e3e3e3;text-align:center;background:#edf1f7;">数量</th>'
										+'<th rowspan="9" style="padding:10px 20px;border:1px solid #fff;text-align:center;">'
											+' <div id="get_briefdoc_'+chartId+'_box" style="width:100%;height:320px; box-sizing:border-box;text-align: center;right:0">'
												 +'<img class="echarts_img" src="get_briefdoc_'+chartId+'_box.png" />'
											+'</div>'
										+'</th>'
									+'</tr>{{get_briefdoc_'+chartId+'_name}}</tbody>'
                            +'</table>'
                            +'</div>'
                            +'</div><br/>';
                        }else if(ele.chartId == 'barEchart'){
                                maptemp ='<div style="margin:0 auto;width: 70%;text-align:center" class="contain-auto"><table cellpadding="0" cellspacing="0" class="yujin-table" style="border:1px solid #e3e3e3;border-collapse: collapse;margin-top:20px;width:100%;text-align:center"><colgroup><col width=""></colgroup>' 
                                +'<thead>'
                                +'<tr><th style="border:1px solid #e3e3e3;"><span style="display: block;height: 30px;line-height: 30px;background: #e42e44;color:#fff">红色预警</span></th>'
                                +'<th style="border:1px solid #e3e3e3;"><span style="display: block;height: 30px;line-height: 30px;background: #f46039;color:#fff">橙色预警</span></th>' 
                                +'<th style="border:1px solid #e3e3e3;"><span style="display: block;height: 30px;line-height: 30px;background: #ff941a;color:#fff">黄色预警</span></th>' 
                                +'<th style="border:1px solid #e3e3e3;"><span style="display: block;height: 30px;line-height: 30px;background: #8a8a99;color:#fff">灰色预警</span></th>' 
                                +'<th style="border:1px solid #e3e3e3;"><span style="display: block;height: 30px;line-height: 30px;background: #35ca7f;color:#fff">绿色预警</span></th></tr>'
                                +'</thead>' 
                                +'<tbody><tr><td style="border:1px solid #e3e3e3;"><span style="display: block;height: 30px;line-height: 30px;">POI≥800</span></td>' 
                                +'<td style="border:1px solid #e3e3e3;"><span style="display: block;height: 30px;line-height: 30px;">POI≥600</span></td>' 
                                +'<td style="border:1px solid #e3e3e3;"><span style="display: block;height: 30px;line-height: 30px;">POI≥300</span></td>'
                                +'<td style="border:1px solid #e3e3e3;"><span style="display: block;height: 30px;line-height: 30px;">POI≥100</span></td>'
                                +'<td style="border:1px solid #e3e3e3;"><span style="display: block;height: 30px;line-height: 30px;">POI&lt;100</span></td></tr></tbody>'
                            +'</table></div>'
                            +'<div style="margin:0 auto; width: 100%;text-align:center;position:relative;height:320px;"  class="contain-auto">'
                                + '<div style="margin:0 auto; width: 833px;">'
                                +'<div id="get_briefdoc_'+chartId+'_box" style="position:absolute;width: 833px;height:100%; box-sizing:border-box;padding:10px;text-align: center">'
                                    +'<img class="echarts_img" src="get_briefdoc_'+chartId+'_box.png" />'
                                +'</div></div>'
                            +'</div>'
                        +'</div><br/>';
                        }else{
                            maptemp = '<div style="margin-left: 13%; width: 74%;text-align:center;position:relative;height:320px;" class="contain-auto">'
                                +'<div id="get_briefdoc_'+chartId+'_box" style="position:absolute;width:100%;height:100%; box-sizing:border-box;padding:10px;text-align: center" class="width870">'
                                    +'<img class="echarts_img" src="get_briefdoc_'+chartId+'_box.png" />'
                                +'</div>'
                            +'</div>'
                        +'</div><br/>';
                        }
                        tempHtml = temptxt + maptemp;
                    }
                    tplHtml += tempHtml;
                }
            }); 
            // if(isHas1){
            //     let temp2 = '<div style="padding:45px 0 0 0;color:#848484;font-size:14px;line-height:22px;margin:0 -15px">'
            //             +'<h3 style="margin:0 0 15px 0;color:#47a0e4;font-size:18px;font-weight:700;">'
            //                 +'<label style="display:inline-block;width:4%;margin:0;text-align:right;"></label>'
            //                 +'<span>'+ that.btNum[btIndex] + '、分析总览</span>'
            //             +'</h3>';
            //     tplHtml += temp2;
            //     tplHtml += zlHtml;                     
            //     tplHtml += '</div>';
            //     btIndex++;
            // }
            // if(isHas2){
            //     let temp3 = '<div style="padding:45px 0 0 0;color:#848484;font-size:14px;line-height:22px;margin:0 -15px">'
            //             +'<h3 style="margin:0 0 15px 0;color:#47a0e4;font-size:18px;font-weight:700;">'
            //                 +'<label style="display:inline-block;width:4%;margin:0;text-align:right;"></label>'
            //                 +'<span>'+ that.btNum[btIndex] + '、热门舆情摘要</span>'
            //             +'</h3>';
            //     tplHtml += temp3;
            //     tplHtml += rmHtml;    
            //     tplHtml += '</div>';
            //     btIndex++;
            // } 
            // if(isHas3){
            //     let tempHtml2 = '<div style="padding:45px 0 0 0;color:#848484;font-size:14px;line-height:22px;margin:0 -15px">'
            //         +'<h3 style="margin:0 0 15px 0;color:#47a0e4;font-size:18px;font-weight:700;">'
            //             +'<label style="display:inline-block;width:4%;margin:0;text-align:right;"></label>'
            //             +'<span>'+ that.btNum[btIndex] + '、处置建议</span>'
            //         +'</h3>'
            //         +'<div style="margin:0 -15px">'
            //             +'<div style="margin-left:8.33333333%;width:91.66666667%;padding:0 15px;box-sizing: border-box;">'
            //                 +'<div><span>'+has3Text+'</span></div>'
            //             +'</div>'
            //         +'</div>'
            //     +'</div>';
            //     tplHtml += tempHtml2;
            // }
            that.tplInit = tplHtml;
            
            
            let data = {
                'openRedHeader':that.status,
                'redTitle':that.tempform.redFileTit,
                'redNumber':that.tempform.redFileName,
                'tplName':that.tempform.tit,
                'tplDesc':that.tempform.name,
                'tplCustom':that.list1,
                'tplInit':that.tplInit
            };
            that.isActive = true;
            that.$parent.loadModal(true,'正在保存...');
            
            if(that.sid==undefined){
                that.$api.post('report/template/create',{data:data},r=>{
                    that.isActive = false;
                    that.$utils.returnCode(r,function(){
                        that.$parent.loadModal(false);
                        that.$utils.alertText('报告添加成功！',200);
                        that.$store.dispatch('show/changeToast',{text:'报告添加成功！'})
                        if(that.isFromTiming){
                            that.$router.push({ path:'/analysis/addTimingTemplate',query:{id:that.timeId}})
                        }else{
                            that.$router.push({ path:'/analysis/ordinaryTemplate'})
                        }
                    });
                });
            }else{
                data.id = that.sid;
                that.$api.post('report/template/edit',{data:data},r=>{
                    that.isActive = false;
                    that.$utils.returnCode(r,function(){
                        that.$parent.loadModal(false);
                        that.$utils.alertText('报告修改成功！',200);
                        that.$store.dispatch('show/changeToast',{text:'报告修改成功！'})
                        that.$router.push({ path:'/analysis/ordinaryTemplate'})
                    });
                });
            }
            that.previewBack();
        },
        //预览模板
        previewOpen(){
            this.isShow = true;
            $('body').addClass('finalDraft');
        },
        previewBack(){
            this.isShow = false;
            $('body').removeClass('finalDraft');
        },
        //编辑模板
        editAjax(){
            let that = this;
            that.$api.get('report/template/info',{id:that.sid},r=>{
                that.$utils.returnCode(r,function(){
                    that.status = parseInt(r.data.openRedHeader);
                    that.$set(that.tempform, 'redFileTit', r.data.redTitle);
                    that.$set(that.tempform, 'redFileName', r.data.redNumber);
                    that.$set(that.tempform, 'tit', r.data.tplName);
                    that.$set(that.tempform, 'name', r.data.tplDesc);
                    that.list1 = r.data.tplCustom;
                    that.list1.forEach((ele,index) => {
                        if (ele.numId != undefined){
                            that.maxName[ele.chartId] = ele.maxId;
                        }
                    });
                    that.list2.forEach((ele,index) => {
                        if (ele.numId != undefined){
                            ele.numId = that.maxName[ele.chartId];
                        }
                    });
                });            
            });
        }
    },
}
</script>
<style >
    .temp-right{width:250px;bottom:34px;top:103px;position:fixed;right:50px}
    .finalDraft{background-color: rgba(0, 0, 0, 0.8);}
    .finalDraft .left-menu,.finalDraft .top-menu,.finalDraft .page-right{display: none}
    .finalDraft .right-div{top:0}
</style>




// WEBPACK FOOTER //
// src/page/yuqingFenxi/presentation/addOrdinaryTemplate.vue